const groupings = {
	Marker: 'Marker',
	Adhoc: 'Ad Hoc',
	Invigilator: 'Invigilator',
	Verifier: 'Verifier',
	AppointmentGroups: 'Appointment Group'
};

export default groupings;
